<template>
  <NotificationBar ref="notificationBar" />
  <UserBarVue
    :updateOrdersCb="fetchLabOrdersByOptionsId"
  />

  <div id="main">

    <div id="tab-wrapper">
      <div
        v-for="tab in filteredTabsArr"
        :key="tab.text"
        class="tab"
        :class="{ selected: selectedTab === tab.selector }"
        @click="selectTab( tab.selector )"
      >
        {{ tab.text }}
      </div>

    </div>

    <!-- FOR EDIT ACCOUNT TAB -->
    <div class="tab-contents FCNW" v-if="selectedTab === 'ACCOUNT'">

      <!-- DIVS FOR TOP LEVEL VALUES -->
      <div class="FRNW button-line">

        <ModernButtonVue
          :disabled="!enableSave"
          :clickFunc="saveChanges"
          :btnText="'Save Changes'"
        />

      </div>
      <div 
        v-for="key of Object.keys( userObj )"
        :key="key"
        class="line FRNW"
      >
        <div class="key">
          {{ separateWords( key ) }}
        </div>
        <div class="value" :title="(key === 'email') ? 'Field is disabled. Contact help to change.' : ''">
          <input 
            class="modern-input"
            type="text"
            v-model="userObjCopy[key]"
            :class="{ changed: userObjCopy[key] !== userObj[key] }"
            :disabled="key === 'email'"
          >
        </div>
      </div>

      <!-- DIVS FOR ADDRESS VALUES -->
      <div 
        v-for="key of Object.keys( userAddress )"
        :key="key"
        class="line FRNW"
      >
        <div class="key">
          {{ separateWords( key ) }}
        </div>
        <div class="value">
          <input 
            class="modern-input"
            type="text"
            v-model="userAddressCopy[key]"
            :class="{ changed: userAddressCopy[key] !== userAddress[key] }"
          >
        </div>
      </div>
    </div>


    <!-- FOR RESET PASSWORDS TAB -->
    <div
      class="tab-contents FCNW"
      v-if="selectedTab === 'PASSWORD'"
    >
      <h1>Manage Password</h1>
      <div>
        <ModernButtonVue
          :btnText="'Change Password'"
          :disabled="!canUpdatePassword"
          :hoverColor="'var(--fla-button-blue)'"
          :hoverFontColor="'white'"
          :clickFunc="resetPassword"
        />
      </div>
      
      <div class="line FRW">
        <div class="key">Current Password:</div>
        <div class="value">
          <input 
            type="text"
            class="modern-input"
            v-model="resetPwObj.current"
            @change="() => resetPwObj.current = resetPwObj.current.trim()"
            placeholder="No leading or trailing spaces."
          >
        </div>
      </div>
      <div class="line FRW">
        <div class="key">New Password</div>
        <div class="value">
          <input 
            type="text"
            class="modern-input"
            v-model="resetPwObj.pw1"
            @change="() => resetPwObj.pw1 = resetPwObj.pw1.trim()"
            placeholder="No leading or trailing spaces."
          >
        </div>
      </div>
      <div class="line FRW">
        <div class="key">Confirm New Password</div>
        <div class="value">
          <input 
            type="text"
            class="modern-input"
            v-model="resetPwObj.pw2"
            @change="() => resetPwObj.pw2 = resetPwObj.pw2.trim()"
            placeholder="No leading or trailing spaces."
          >
        </div>
      </div>

    </div>

    <!-- FOR EDIT LAB INFO -->
    <div 
      class="FCNW" 
      v-if="selectedTab === 'LAB_INFO'"
      style="text-align: left;"
    >

      <h1>Build and Edit Your Lab's Order Options</h1>
 
        <div>
          <ModernButtonVue
            :btnText="'Preview Order Page'"
            :clickFunc="openOrderPreviewPage"
            :hoverColor="'var(--fla-button-blue)'"
            :hoverFontColor="'white'"
            :title="'Preview Lab Order Page'"
          />
        </div>
      
      <div class="line FRW">
        <div class="key">Lab Name:</div>
        <div class="value">
          <input 
            type="text"
            class="modern-input"
            v-model="labOptions.labName"
            @change="trimLabName"
            placeholder="No leading or trailing spaces."
          >
        </div>
        <div>
          <ModernButtonVue
            :btnText="'Update Lab Name'"
            :clickFunc="updateLabName"
            :disabled="!canUpdateLabName"
          />
        </div>
      </div>

      <div id="about-string" class="FCNW">
        <h2>Lab About Section</h2>
        <div class="line">
          <ModernButtonVue
          :clickFunc="updateAbout"
          :btnText="'Update'"
          />
        </div>
        <div class="about-section">
          <textarea
            class="custom-text-area"
            name="" 
            id=""
            rows="10" 
            v-model="labOptions.aboutString"
          ></textarea>
        </div>

      </div>


      <div id="lab-logo" class="FCNW">
        <h2>Upload/Remove Logo</h2>

        <!-- LOGO EXISTS - PREVIEW IT WITH REMOVE BUTTON -->
        <div 
          v-if="labOptions?.labLogo?.presignedUrl"
          class="FCNW"
          style="align-items: center;"
        >
          <img
            style="max-width: 15rem; max-height: 15rem; object-fit: contain;"
            :src="labOptions?.labLogo?.presignedUrl" 
            :alt="labOptions?.labLogo?.fileName"
          >
          <div class="FRNW">
            <ModernButtonVue
              :clickFunc="removeLogo"
              :btnSize="'small'"
              :btnText="'Remove Logo'"
              :backgroundColor="'#F4CCCC'"
              :title="'Permanently removes logo from database.'"
            />
          </div>
        </div>

        <!-- NO LOGO - SHOW UPLOADER -->
        <div v-else>
          <AWS_FileUploaderVue
            :userId="userId"
            :uploadCb="this.fetchUser"
          />
        </div>

      </div>



      <!-- SECTION FOR VARIOUS OPTIONS -->
      <!-- --------------------------- -->
      <div 
        class="option-container" 
        v-for="[key, title] of Object.entries(labOptionsArrayMap)"
        :key="key"
      >
        <h2>{{ title }}</h2>
        <div>
          <div class="btn-line FRNW">
            <ModernButtonVue
              :clickFunc="() => addLabOption(key)"
              :btnText="'Add Option'"
              :title="'Add additional option for the dropdown list.'"
            />
          </div>

          <LabOption_Component
            v-for="(option, index) in labOptions[key]"
            :key="index"
            :optionObj="option"
            :mainKey="key"
            :labOptionsId="labOptions?._id || null"
            :userId="userId"
            :removeOption="( data ) => removeLabOption( data )"
            :fetchUser="fetchUser"

          />

        </div>

      </div>

      <!-- NEGATIVE RETURN OPTIONS SECTION -->
      <div 
        class="option-container" 
        key="negative-return-options"
      >
        <h2>Negative Return Options</h2>
        <div id="negative-return-options-div" class="row">
          <div class="line FRNW">
            <input 
              type="checkbox" 
              v-model="labOptions.willShipNegatives"
              @change="updateNegativeOption( 'willShipNegatives' )"
            >
            <div class="FRNW">
              <label>Will ship negatives</label>
              <InfoVue
                :title="'Click checkbox if you will ship negatives back to customer.'"
              />
            </div>
          </div>
          <div class="line FRNW">
            <input 
              type="checkbox" 
              v-model="labOptions.shipNegativesCostPerItem"
              @change="updateNegativeOption( 'shipNegativesCostPerItem' )"
              :disabled="!labOptions.willShipNegatives"
            >
            <div class="FRNW">
              <label>Cost is per item?</label>
              <InfoVue
                :title="'Click checkbox if you want to charge the below cost per order item. If shipping cost is per order leave this unchecked.'"
              />
            </div>
          </div>
          <div class="line FRNW">
            <label>Cost $</label>
            <input 
              type="Number" 
              class="modern-input"
              v-model="labOptions.shipNegativesCostDollars"
              @change="updateNegativeOption( 'shipNegativesCostDollars' )"
              :disabled="!labOptions.willShipNegatives"
            >
          </div>
        </div>
      </div>
      <!-- --------------------------- -->

    </div>


    <!-- FOR EDIT LAB PREFERENCES - payment email details ect. -->
     <div class="tab-contents FCNW" v-if="selectedTab === 'LAB_PREFERENCES'">

      <div class="sub-section FCNW">
        <h3>Misc Business Settings</h3>

        <div class="sub-section-body FRNW">
          <div class="FRNW">
            <input 
              type="checkbox" 
              v-model="labOptions.labIsTakingOrders"
              @change="updateLabIsTakingOrders"
            >
            <label>Lab is taking orders?</label>
            <InfoVue
              :title="'Uncheck to deactivate orders page.'"
            />
          </div>
        </div>

      </div>

      <div class="sub-section FCNW">
        <h3>Payment Settings</h3>
        <div class="sub-section-body FRNW">
          
          <!-- TAX INFO -->
          <div class="FCNW tax-info">
            <div class="body-line">
              <input 
                type="checkbox" 
                v-model="labOptions.includeTax"
                @change="updateIncludeTax"
              >
              <label>Include Tax</label>
            </div>
            <div class="body-line">
              <label>Tax Rate (%):</label>
              <input 
                type="number" 
                v-model="labOptions.taxRate"
                min="0" 
                max="100"
                @change="updateTaxRate"
              >
            </div>
          </div>

          <!-- PAYMENT INFO -->
          <div class="FCNW payment-info">
            
            <div class="body-line">
              <label>Square Application ID</label>
              <input 
                type="text" 
                placeholder="Square api key found in developer site."
                v-model="squareApplicationId"
              >
              <InfoVue
                :title="squareKeyInfo"
              />
            </div>
            <div class="body-line">
              <ModernButtonVue
                :btnText="'Submit Application ID'"
                :btnSize="'small'"
                :showBorder="true"
                :clickFunc="() => submitSquareKeys('squareApplicationId')"
                :disabled="squareApplicationId === labOptions.squareApplicationIdDecrypted"
              />
            </div>

            <div class="body-line">
              <label>Square Access Token</label>
              <input 
                type="text" 
                placeholder="Square api key found in developer site."
                v-model="squareAccessToken"
              >
              <InfoVue
                :title="squareKeyInfo"
              />
            </div>
            <div class="body-line">
              <ModernButtonVue
                :btnText="'Submit Access Token'"
                :btnSize="'small'"
                :showBorder="true"
                :clickFunc="() => submitSquareKeys('squareAccessToken')"
                :disabled="squareAccessToken === labOptions.squareAccessTokenDecrypted"
              />
            </div>
          </div>
        </div>
        
        
      </div>

      <div class="sub-section FCNW">
        <h3>Email Preferences</h3>
        <div class="email-info">
          <div>
            <input 
              type="checkbox" 
              v-model="labOptions.emailOnAllOrderUpdates"
              @change="updateEmailSetting('emailOnAllOrderUpdates')"
            >
            <label>Email Customers on ALL Order Updates</label>
          </div>
          <div>
            <input 
            type="checkbox" 
            v-model="labOptions.carbonCopyOnEmails"
            @change="updateEmailSetting('carbonCopyOnEmails')"
            >
            <label>Carbon Copy on Emails</label>
          </div>
        </div>
        
      </div>

      <div class="sub-section FCNW">
        <h3>Add Lab Users</h3>
        <div class="sub-section-body FCNW">
          <div id="add-lab-user-div">
            <input 
              type="text" 
              placeholder="user's email"
              v-model="addLabUserEmail"
            >
            <ModernButtonVue
              :btnText="'Add User'"
              :clickFunc="addLabUser"
              :disabled="disableAddLabUserBtn"
              :btnSize="'extra-small'"
              :showBorder="true"
            />
          </div>
          <div id="lab-users-div" class="FRNW">
            <div 
              v-for="user of labUsers" 
              :key="user._id"
              class="lab-user"
            >
              <div 
                :title="`${user.firstName} ${user.lastName}`"
                style="cursor:help"
              >
                {{ user.email }}
              </div>
              <div style="margin-left: .25rem;">
                <CloseBtnVue
                  :title="'remove lab user'"
                  :closeFunc="() => removeLabUser( user._id )"
                />
              </div>
            </div>
          </div>
        </div>

      </div>

     </div>


    <!-- FOR ORDERS SECTION -->
    <div class="tab-contents FCNW" v-if="selectedTab === 'ORDERS'">

      <!-- FOR LAB ACCOUNTS -->
      <OrdersViewLab_ComponentVue
        v-if="isLabAccount || isLabMember"
        :presignedLogoUrl="labOptions?.labLogo?.presignedUrl"
        :labOptionsId="(isLabMember) ? userObj.userOfLab : undefined"
      />


      <!-- FOR USER ACCOUNTS -->
       <OrdersViewUser_ComponentVue
        v-if="!isLabAccount && !isLabMember"
        :userId="userId"
       />

    </div>

    <div class="tab-contents FCNW" v-if="selectedTab === 'REPORTS'">
      <ReportsView_Component
      />
    </div>



  </div>

</template>

<script>
import NavBar from '../components/NavBar.vue';
import NotificationBar from '../components/NotificationBar.vue';
import LabOption_Component from '../components/LabOption_Component.vue';

import _ from 'lodash';
import ModernButtonVue from '@/components/basicComponents/ModernButton.vue';
import OrdersViewLab_ComponentVue from '@/components/OrdersViewLab_Component.vue';
import OrdersViewUser_ComponentVue from '@/components/OrdersViewUser_Component.vue';
import UserBarVue from '@/components/basicComponents/UserBar.vue';
import InfoVue from '@/components/basicComponents/Info.vue';
import AWS_FileUploaderVue from '@/components/basicComponents/AWS_FileUploader.vue';
import CloseBtnVue from '@/components/basicComponents/CloseButton.vue';
import ReportsView_Component from '@/components/ReportsView_Component.vue';

import 'awesomplete/awesomplete.css';
import { SeparateWords, AesEncrypt, AesDecrypt, Encrypt, LocalStorageFuncs, ValidateEmail } from '../utils';
import router from '../router/index.js';





// GLOBALS
// --------------------
const API = process.env.VUE_APP_API_URL;
let NOTIFICATION, FLA_AXIOS;
const NAME = 'UserAccount';
// --------------------


export default {
  name: NAME,
  components: {
    NavBar,
    NotificationBar,
    LabOption_Component,
    ModernButtonVue,
    OrdersViewLab_ComponentVue,
    OrdersViewUser_ComponentVue,
    InfoVue,
    UserBarVue,
    AWS_FileUploaderVue,
    CloseBtnVue,
    ReportsView_Component
  },
  data() {
    return {
      selectedTab: 'ACCOUNT',
      // selectedTab: 'LAB_PREFERENCES',
      // selectedTab: 'LAB_INFO',
      userName:'',
      userId: '',
      isLabAccount: false,
      isLabMember: false,
      userObj: {},
      userAddress: {},
      userObjCopy:{},
      userAddressCopy: {},
      canSave: false,

      labOptions: {},
      labOptionsCopy: {},

      labOptionsArrayMap: {
        // filmChemistry: 'Film Processing Options',
        // format: 'Film Format',
        // pushPullProcessing: 'Push/Pull',
        // negativeOptions: 'Negative Options',
        // negativeReturnOptions: 'Film Return Options'
      },
      // labOptionsObj: {
      //   filmChemistry: 'Film Processing Options',
      //   format: 'Film Format',
      //   pushPullProcessing: 'Push/Pull',
      //   negativeOptions: 'Negative Options',
      //   negativeReturnOptions: 'Film Return Options'
      // },

      squareKeyInfo: '1) Go to developer.squareup.com/console/apps\n2) Click on application or "+" to create a new application.\n3) Click on "Production" tab and copy the "Production Access token" and past it here.',
      squareApiKey: '',
      squareAccessToken: '',
      squareApplicationId: '',

      apiKeyKeys: [
        'squareAccessToken',
        'squareApplicationId'
      ],

      resetPwObj: {
        current: '',
        pw1: '',
        pw2: ''
      },

      addLabUserEmail: '',
      labUsers: [],

      // array to generate tabs at the top of page
      tabsArr: [
        {
          text: 'Edit Account',
          selector: 'ACCOUNT',
          allUsers: true,
        },
        {
          text: 'Manage Password',
          selector: 'PASSWORD',
          allUsers: true,
        },
        {
          text: 'Lab Info',
          selector: 'LAB_INFO',
          allUsers: false,
        },
        {
          text: 'Lab Preferences',
          selector: 'LAB_PREFERENCES',
          allUsers: false,
        },
        {
          text: 'Orders',
          selector: 'ORDERS',
          allUsers: true,
        },
        {
          text: 'Reports',
          selector: 'REPORTS',
          allUsers: false,
        }
      ]
    }
  },
  computed: {
    enableSave() {

      const userObjMissmatch = Object
        .keys( this.userObj )
        .some( key => {
          return this.userObj[key] !== this.userObjCopy[key]
        } );

      const userAddressObjMissMatch = Object
        .keys( this.userAddress )
        .some( key => {
          return this.userAddress[key] !== this.userAddressCopy[key];
        } );

      return ( userObjMissmatch || userAddressObjMissMatch );
    },
    
    canUpdateLabName() {
      return this.labOptions?.labName !== this.labOptionsCopy?.labName
    },

    canUpdatePassword() {
      const { pw1, pw2 } = this.resetPwObj;

      return (
        pw1.trim() !== '' &&
        pw2.trim() !== '' &&
        pw1.trim() === pw2.trim()
      );
    },

    disableAddLabUserBtn() {
      return !ValidateEmail( this.addLabUserEmail );
    },

    filteredTabsArr() {
      if ( this.isLabAccount ) return this.tabsArr;
      
      return this.tabsArr.filter( x => x.allUsers );
    },

  },
  methods: {

    selectTab( tab ) {
      this.selectedTab = tab;
      localStorage.setItem('FLA_USER_ACCOUNT_TAB', tab);
    },

    fetchLabOptionsArrayMap() {
      FLA_AXIOS('get', API + '/api/labOptions/labOptionsArrayMap' )
        .then( res => {
          const { labOptionsArrayMap } = res.data;
          this.labOptionsArrayMap = labOptionsArrayMap;
        } )
        .catch( e => console.log(e) );
    },

    fetchUser( cb ) {
      const token = LocalStorageFuncs.fetchToken();
      this.axios
        .get( API + `/api/user/fetchUser/${token}`  )
        .then( res => {
          const { userObj, userAddress, userId, accountType, labOptions, labUsers } = res.data;

          // since there is no user object we know the session has ended, redirect to origin
          if ( !userObj ) {
            setTimeout( () => {
              // return to home page
              router.push('/');
            }, 4000 );
            NOTIFICATION( res.data );            
            return;
          }

          // set user fields
          this.userId = userId;
          this.isLabAccount = accountType === 'LAB';
          
          // decrypt for users to see values
          this.decryptApiKeys( labOptions );
          
          this.labOptions = labOptions;
          this.labOptionsCopy = JSON.parse( JSON.stringify( labOptions || {} ) );
          this.labOptionsId = labOptions?._id || null;
          this.userObj = userObj;
          this.userAddress = userAddress;
          this.userObjCopy = JSON.parse( JSON.stringify( userObj ) );
          this.userAddressCopy = JSON.parse( JSON.stringify( userAddress ) );

          // check if labMember value should be set to true
          const showLabMemberLocalStorage = localStorage.getItem('FLA_SHOW_LAB_ORDERS');
          console.log(showLabMemberLocalStorage)
          if ( showLabMemberLocalStorage === 'true' ) this.isLabMember = true;

          // fetch labUsers if any
          if ( labOptions?._id ) this.fetchLabUsers( labOptions._id );

          if ( cb ) {
            console.log('there is a callback')
            this.$nextTick( cb );
            // cb();
            this.$forceUpdate();
          }
        } )
        .catch( e => console.log( e ) )
    },

    separateWords( str ) {
      return SeparateWords( str );
    },

    // this is used to update api keys after successful update
    setApiKeys () {
      this.apiKeyKeys.forEach( x => {
        const _key = `${x}Decrypted`;
        this.labOptions[_key] = this[x];
      } );
    },

    decryptApiKeys( labOptions ) {
      if ( !labOptions ) return;


      // loop through keys (assuming there will be more)
      this.apiKeyKeys.forEach( key => {
        
        // create decrypted key
        const _key = `${key}Decrypted`;

        // decrypt key from BE

        const [e, decryptedString] = AesDecrypt( labOptions[key] );

        // if error, do nothing
        if ( e ) return;

        // set value within labOptions
        labOptions[_key] = decryptedString

        // set value fields also, this is needed to populate the inputs
        this[key] = decryptedString;
      } );
    },

    saveChanges() {

      const data = { 
        userObj: this.userObjCopy,
        userAddress: this.userAddressCopy,
        userId: this.userId,
      };

      this.axios
        .post( API + '/api/user/updateUser', data )
        .then( res => {
          NOTIFICATION( res.data );

          // just reset the data, no need to re-fetch since the user will not be logged anywhere else
          this.userObj = JSON.parse( JSON.stringify( this.userObjCopy ) );
          this.userAddress = JSON.parse( JSON.stringify( this.userAddressCopy ) );
          

          // TODO: refetch user data or just reset it based on the copy
        } )
        .catch( e => console.log( e ) );
    },

    addLabOption( type ) {

      // make sure there is an array to push to
      if ( !this.labOptions[type] ) this.labOptions[type] = [];

      // basic object, new needs to === true for BE
      const obj = {
        optionText: '',
        costDollars: 0, 
        new: true,
      };

      this.labOptions[type].push( obj )
    },

    removeLabOption( data ) {
      FLA_AXIOS('post', API + '/api/labOptions/removeOption', data )
        .then( res => {
          NOTIFICATION( res.data );
          this.fetchUser();
        } )
        .catch( e => console.log(e) );
    },

    updateAbout() {
      const data = {
        labOptionsId: this.labOptionsId,
        aboutString: this.labOptions?.aboutString || null,
      };

      FLA_AXIOS('post', API + '/api/labOptions/updateAbout', data)
        .then( res => {
          NOTIFICATION( res.data );
        } )
        .catch( e => console.log(e));
    },

    updateLabName() {
      const data = {
        labOptionsId: this.labOptionsId,
        labName: this.labOptions.labName?.trim(),
      };

      FLA_AXIOS('post', API + '/api/labOptions/updateLabName', data)
        .then( res => {
          NOTIFICATION( res.data );
          this.labOptionsCopy = JSON.parse( JSON.stringify( this.labOptions ) );
        } )
        .catch( e => console.log(e) )
    },

    trimLabName() {
      this.labOptions.labName = this.labOptions.labName?.trim();
      this.labOptionsCopy.labName = this.labOptionsCopy.labName?.trim();
    },

    submitSquareKeys( keyName ) {

      // encrypt key before sending to API
      const [ encryptErr, keyVal ] = AesEncrypt( this[keyName] );

      if ( encryptErr ) {
        return NOTIFICATION( { notification: {
          msg: 'Error encrypting key.',
          type: 'error'
        } } );
        
      }
      const data = { 
        keyName, 
        keyVal,
        userId: LocalStorageFuncs.fetchUserId(),
        token: LocalStorageFuncs.fetchToken(),
      };

      FLA_AXIOS('post', API + '/api/labOptions/updateApiKey', data)
      .then( res => {
        NOTIFICATION( res.data );

        // reset FE values
        this.setApiKeys();
      } )
      .catch( e => console.log(e) )
    },

    updateIncludeTax() {
      const data = {
        labOptionsId: this.labOptions._id,
        includeTax: this.labOptions.includeTax,
      };
      FLA_AXIOS('post', API + '/api/labOptions/updateIncludeTax', data)
      .then( res => {
        NOTIFICATION( res.data );
      } )
      .catch( e => console.log(e) )
    },

    updateLabIsTakingOrders() {
      const data = {
        labOptionsId: this.labOptions._id,
        labIsTakingOrders: this.labOptions.labIsTakingOrders,
      };
      FLA_AXIOS('post', API + '/api/labOptions/updateLabIsTakingOrders', data)
      .then( res => {
        NOTIFICATION( res.data );
      } )
      .catch( e => console.log(e) )
    },

    updateTaxRate() {
      const data = {
        labOptionsId: this.labOptions._id,
        taxRate: this.labOptions.taxRate,
      };
      FLA_AXIOS('post', API + '/api/labOptions/updateTaxRate', data)
      .then( res => {
        NOTIFICATION( res.data );
      } )
      .catch( e => console.log(e) )
    },

    updateEmailSetting( key ){
      const val = this.labOptions[key];
      console.log(val)
      // return
      const msgVal = SeparateWords(key);
      const labOptionsId = this.labOptions._id;
      const data = { key, val, msgVal, labOptionsId };
      FLA_AXIOS('post', API + '/api/labOptions/updateEmailSetting', data)
      .then( res => {
        NOTIFICATION( res.data );
      } )
      .catch( e => console.log(e) )
    },

    openOrderPreviewPage() {
      const labOptionsId = this.labOptions._id;
      const path = `/lab/order?labId=${labOptionsId}`;
      const { origin }  = window.location;
      window.open(`${origin}${path}`,'_blank').focus();
    },

    resetPassword() {
      const { pw1, current } = this.resetPwObj;

      const data = {
        pw1: Encrypt( pw1 ),
        currentPw: current,
        uId: LocalStorageFuncs.fetchUserId(),
        token: LocalStorageFuncs.fetchToken(),
      };

      const url = API + '/api/user/changePassword';
      FLA_AXIOS('post', url, data)
      .then( res => {
        NOTIFICATION( res.data );
        this.resetPwObj = {
          current: '',
          pw1: '',
          pw2: ''
        };
      } )
      .catch( e => console.error(e) );
    },

    removeLogo() {
      const data = { userId: this.userId };
      const url = API + '/api/user/removeLogo';
      FLA_AXIOS('post', url, data)
      .then( res => {
        this.fetchUser();
        NOTIFICATION( res.data );
      } )
      .catch( e => console.error( e ) );
    },

    addLabUser() {
      const data = {
        labOptionsId: this.labOptions._id,
        userEmail: this.addLabUserEmail
      };
      const url = API + '/api/user/addLabUser';
      FLA_AXIOS('post', url, data)
      .then( res => {
        this.addLabUserEmail = '';
        this.fetchLabUsers();
        NOTIFICATION( res.data );
      } )
      .catch( e => console.error(e) );
    },

    removeLabUser( userId ) {
      const data = {
        labOptionsId: this.labOptions._id,
        userId
      };
      FLA_AXIOS('post', API + '/api/user/removeLabUser', data)
      .then( res => {
        this.fetchLabUsers();
        NOTIFICATION( res.data );
      })
      .catch( e => console.error( e ) );

    },

    fetchLabUsers() {
      const data = { labOptionsId: this.labOptions._id };
      FLA_AXIOS('get', API + `/api/user/fetchLabUsers/${this.labOptions._id}`)
      .then( res => {
        this.labUsers = res?.data?.labUsers || [];
      })
      .catch( e => console.error( e ) );
    },

    fetchLabOrdersByOptionsId() {
      this.isLabMember = !this.isLabMember;
    },


    updateMarginDefault() {
      let marginValue;
      const width = window.innerWidth;

      if ( width <= 700 ) {
        marginValue = '1%';
      }
      else if ( width <= 1000 ) {
        marginValue = '5%';
      }
      else if ( width <= 1500) {
        marginValue = '10%';
      }
      else marginValue = '15%';

      document.documentElement.style.setProperty('--margin-default', marginValue);
    },

    updateNegativeOption( field ) {
      const val = this.labOptions[field];
      const data = { field, val, labOptionsId: this.labOptions._id };

      const url = API + '/api/labOptions/updateNegativeOption'
      FLA_AXIOS('post', url, data)
      .then( res => {
        NOTIFICATION( res.data )
      })
      .catch( e => console.error( e ) )
    }

  },
  mounted() {
    // set globals
    NOTIFICATION = this.$refs.notificationBar.showNotification;
    FLA_AXIOS = window.FLA_Axios;

    // fetch user data
    this.fetchUser();

    // fetch key/title map for labOptions
    this.fetchLabOptionsArrayMap();

    // set user margin TODO: figure out a better way for this
    window.addEventListener('resize', this.updateMarginDefault);
    this.updateMarginDefault();   // need to call to trigger

    window[NAME] = this;

    // set selected tab
    const selectedTab = localStorage.getItem('FLA_USER_ACCOUNT_TAB');
    this.selectedTab = selectedTab || 'ACCOUNT'
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMarginDefault);
  },
}


</script>

<style>

:root {
  --margin-default: 20%;
  --border-radius: 10px;
  --border-size-orders: 1px;
  --border-color-orders: gray;
  --border-orders: 1px solid gray;
}

.FRNW {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.FRW {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.FCNW {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

#main {
  display: flex;
  flex-direction: column;
  height: 100%;
  /* margin: 0 var(--margin-default); */
  padding: 0 1rem;
  /* Pale Rose */
  /* background-color: #EFD3D7; */

  /* Mint Green */
  /* background-color: #D5E8D4; */

  /* Dusty Blue */
  /* background-color: #B0C4DE; */

  /* Peach Puff */
  /* background-color: #FFDAB9; */

  /* Lavender Blush */
  /* background-color: #FFF0F5; */

  /* Antique White */
  /* background-color: #FAEBD7; */

  /* Sage Green */
  /* background-color: #C3B091; */

  /* Champagne */
  /* background-color: #F7E7CE; */

  /* Soft Coral */
  /* background-color: #F4CCCC; */

  /* Powder Blue */
  /* background-color: #B0E0E6; */
  overflow: auto;

}

#tab-wrapper {
  display: flex;
  overflow: auto;
  min-height: 5rem;
  /* flex-wrap: nowrap; */
  /* padding-left: 20%; */
  /* padding-left: var(--margin-default); */
}

.tab {
  margin: 0.5rem;
  padding: 0.25rem 1rem;
  border-radius: 10px;
  align-content: center;
  justify-items: center;
}

.tab2 {
  margin: 0.5rem;
  /* padding: 1rem; */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.span1 {
  padding: 1rem;
}

.span2 {
  display: hidden;
}
.tab2.selected.span2{
  border: 1px solid black;
}

.tab:hover, .tab2:hover {
  background-color: whitesmoke;
  cursor: pointer;
}

.tab.selected {
  text-decoration: underline;
  font-weight: bold;
}

.line, .btn-line {
  border-bottom: 2px solid gray;
  /* margin: 0 20% 1rem 20%; */
  /* margin: 0 var(--margin-default) 1rem var(--margin-default); */
  margin: 0 2rem .5rem 2rem;
  padding: .5rem;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.btn-line {
  border-bottom: 0px !important;
  margin-bottom: 0px;
}

.key { 
  text-align: left; 
  font-weight: bold;
}
/* .value { text-align: right; } */

/* Modern input style */
.modern-input {
    /* width: 300px; */
    width: 18rem;
    /* padding: 12px 20px; */
    /* padding: .75rem 1.25rem; */
    padding: .5rem .75rem;
    /* margin: 8px 0; */
    margin: .5rem 0;
    /* font-size: 16px; */
    font-size: 1rem;
    color: #333;
    background-color: #f1f1f1;
    border: none;
    border-radius: 4px;
    outline: none;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    box-sizing: border-box;
    text-align: right;
}

/* Focus effect */
.modern-input:focus {
    background-color: #e0e0e0;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.modern-input:disabled {
  background-color: gray;
}

.changed {
  background-color: #D5E8D4; 
}

/* Modern button styling */
/* TODO - I THINK THESE CAN ALL BE REMOVED SINCE THEY RESIDE IN THE COMPONENT. */
.modern-button {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  /* color: #fff; */
  color: black;
  /* background-color: #007BFF; */
  background-color: #D5E8D4;
  border: none;
  border-radius: 5px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  
  /* transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease; */
}

.modern-button:disabled {
  background-color: gray;
  color: #fff;
}

/* Hover effect */
.modern-button:hover:not(:disabled) {
  /* background-color: #0056b3; */
  background-color: #C3B091;
  cursor: pointer;
  /* box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15); */
}


.button-line {
  margin: 0 var(--margin-default);
  flex-direction: row-reverse;
}

.custom-text-area {
  margin: 1rem var(--margin-default);
  align-items: center;
  resize: vertical;
}

.sub-section {
  border: 1px solid gray;
  border-radius: 10px;
  background-color: gainsboro;
  background-color: var(--fla-gray);
  margin: 1rem;
  padding: 1rem;
}

.sub-section label {
  font-weight: bold;
  margin: 0 0.25rem;
}

.sub-section input[type='checkbox'] {
  cursor: pointer;
}

.sub-section-body {
  justify-content: space-between;
}

.body-line {
  display: flex;
  align-items: center;
}

.tax-info, .payment-info, .email-info{
  border: 1px solid gray;
  border-radius: var(--border-radius);
  background: whitesmoke;
  padding: 1rem;
}
/* .tax-info label, .payment-info label {
  font-weight: bold;
  margin: 0 .25rem;
} */

#negative-return-options-div {
  display: flex;
  flex-direction: column;
  background-color: gainsboro;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
  font-weight: bold;
}
#negative-return-options-div .line{
  transition: all .3s;
}
#negative-return-options-div .line input[type='checkbox']{
  cursor: pointer;
}
#negative-return-options-div .line:hover{
  background-color: #C3B091;
}

.lab-user {
  display: flex;
  flex-direction: row;
  padding: .5rem;
  margin: 0 .5rem;
  border: 1px solid black;
  border-radius: var(--border-radius);
  align-items: center;
  background-color: whitesmoke;
  transition: .3s;
}

.lab-user:hover {
  background-color: var(--fla-hover-green);
}

@media ( max-width: 600px ) {
  .line {
    border-bottom: 2px solid gray;
    /* margin: 0 20% 1rem 20%; */
    margin: 0 var(--margin-default) 1rem var(--margin-default);
    padding: .5rem;
    justify-content: space-between;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

}

</style>